import { PITCH_DOWN_THRESHOLD } from '../constants';
import type { FrameResult } from '../types';
import { BaseChallenge } from './base-challenge';

export class PitchDownChallenge extends BaseChallenge {
  constructor() {
    super('pitch_down');
  }

  processFrame(frame: FrameResult): void {
    if (!frame.headPose) {
      return;
    }

    this.captureFrame();

    const { pitch } = frame.headPose;

    const progress = Math.max(
      Math.min((pitch - PITCH_DOWN_THRESHOLD) / PITCH_DOWN_THRESHOLD, 1),
      0,
    );
    this.reportProgress(progress);

    if (pitch > PITCH_DOWN_THRESHOLD) {
      this.pass(0.9);
    }
  }
}
